import { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row, Input, Button, Table } from "reactstrap";
import { getPatientsByAdmin } from "../../Api/patient";
import { toast } from "react-toastify";
import { Search } from "react-feather";
import axios from "axios";
import { H4, Btn, H5, H6 } from "../../AbstractElements";
import GeneratingLoader from "../../CommonElements/GeneratingLoader/GeneratingLoader";
import ReactPaginate from 'react-paginate';
import { Badge } from "reactstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const AdminPatients = () => {
  const navigate = useNavigate()
  const [patients, setPatients] = useState<any>([]);
  const [tempQuery, setTempQuery] = useState("");
  const [loading, setLoading] = useState(false)

  const [perPage, setPerPage] = useState<number>(5);
  const [patientItems, setPatientItems] = useState<any>([]);
  const [patientOffset, setPatientOffset] = useState(0);
  const [patientPageCount, setPatientPageCount] = useState(0);

  const getPatients = async () => {
    try {
      const response = await getPatientsByAdmin();
      if (response.status === 'success') {
        const _patients = response.payload
        setPatients(_patients)
      }
      else {
        if (response.response)
          toast.error(response.response.data.message)
        else
          toast.error("Get user list Error!")
      }
    } catch (error) {
      toast.error("Get user list failed!");
    }
  }

  const handleSearch = async () => {
    try {
      setLoading(true)
      const response: any = await axios.get(`/patient/list?query=${tempQuery}`)
      setPatients(response.data.payload.patients)
      setLoading(false)
    } catch (err: any) {
      console.log(err)
      setLoading(false)
    }
  }

  useEffect(() => {
    getPatients()
  }, [])

  useEffect(() => {
    const endPatientOffset = patientOffset + perPage;
    setPatientItems(
      patients.slice(patientOffset, endPatientOffset)
    )

    setPatientPageCount(Math.ceil(patients.length / perPage))
  }, [perPage, patientOffset, patients])

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * perPage) % patients.length;
    setPatientOffset(newOffset)
  }

  const handleChangePerPage = (e: any) => {
    setPerPage(parseInt(e.target.value))
  }


  return (
    <div className='page-body default-dashboard dashboard-2'>
      {loading && <GeneratingLoader label="Loading..." />}
      <Card>
        <CardBody>
          <Row>
            <h5 className="mb-1" style={{ fontSize: 18 }}> {"Browse"}</h5>
            <Col sm={8} className="d-flex mb-3" style={{ gap: 8 }}>
              <Input
                className="border "
                placeholder="Search by name"
                onChange={(e) => {
                  setTempQuery(e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
                value={tempQuery} />
              <Button
                className="px-3 pt-2 pb-1"
                onClick={() => handleSearch()}
              >
                <Search width={20} height={18} />
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardHeader className={"card-no-border pb-0"}>
          <div className={`header-top`}>
            <H4>{"Patients List"}</H4>
            <Btn color="primary" onClick={() => navigate("/patient-form")}>New Patient</Btn>
          </div>
        </CardHeader>
        <CardBody className="pt-0 projects px-0">
          <div className="dataTables_wrapper">
            <div className="table-responsive theme-scrollbar">
              <Table className="table display dataTable no-footer" id="selling-product">
                <thead>
                  <tr>
                    <th>
                      {"No"}
                    </th>
                    <th style={{minWidth: "120px"}}>{"Patient Name"}</th>
                    <th style={{minWidth: "140px"}}>{"Clinician Name"}</th>
                    <th style={{minWidth: "180px"}}>{"Address"}</th>
                    <th>{"Email"}</th>
                    <th>{"Phone number"}</th>
                    <th>{"Type"}</th>
                    <th>{"School"}</th>
                    <th>{"Teacher Email"}</th>
                    <th>{"GP Email"}</th>
                    <th style={{minWidth: "150px"}}>{"Joined At"}</th>
                  </tr>
                </thead>
                <tbody>
                  {patientItems[0] ? patientItems.map((patient: any, i: any) => (
                    <tr key={i}>
                      <td>
                        {i + 1}
                      </td>
                      <td>{`${patient.firstname} ${patient.lastname}`}</td>
                      <td>{`${patient.clinician.firstname} ${patient.clinician.lastname}`}</td>
                      <td> {patient.address}</td>
                      <td> {patient.email}</td>
                      <td> {patient.phonenumber}</td>
                      <td><Badge className="text-capitalize" color={`${patient.type === "adult" ? "primary" : "secondary"}`}>{patient.type}</Badge></td>
                      <td>{patient.school}</td>
                      <td>{patient.teacher_email}</td>
                      <td>{patient.gp_email}</td>
                      <td>{moment(patient.created_at).format("YYYY-MM-DD")}</td>
                    </tr>
                  )) :
                    <tr>
                      <td colSpan={11} className="text-center">
                        <div className="px-3 py-3">
                          <span style={{ fontSize: 16 }}>No patients at the moment</span>
                        </div>
                      </td>
                    </tr>}
                </tbody>
              </Table>
            </div>
            <div className=" d-flex justify-content-end align-items-center pagination-container mt-3" style={{ gap: 16 }}>

              <div className="d-flex align-items-center items-per-page" style={{ gap: 8 }}>
                <H5>Per Page : </H5>
                <Input
                  type="number"
                  value={perPage}
                  onChange={(e: any) => handleChangePerPage(e)}
                  style={{ width: 50, textAlign: 'center' }}
                />
              </div>
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <div>
                  <ReactPaginate
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={1}
                    pageCount={patientPageCount}
                    previousLabel="<"
                    breakLabel="..."
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item page-item-previous"
                    previousLinkClassName="page-link"
                    nextClassName="page-item page-item-next"
                    nextLinkClassName="page-link"
                    breakClassName="page-item page-item-break"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </div>
            </div>
          </div>
        </CardBody>

      </Card>
    </div>
  )
}

export default AdminPatients;